/**
 * Auth LocalStorage Service
 *
 * Handles the device ID. The access token is not stored: it lives in memory
 * (see accessToken.service.ts).
 */

import { AUTH_CONSTANTS } from "../configs/constants";

const { STORAGE_KEYS } = AUTH_CONSTANTS;

/**
 * Get or generate device ID
 * Device ID is used to identify the device for 2FA
 */
export const getAuthDeviceId = (): string => {
  let deviceId = localStorage.getItem(STORAGE_KEYS.DEVICE_ID);
  deviceId ??= generateNewDeviceId();
  return deviceId;
};

/**
 * Generate a new unique device ID and save to localStorage
 */
export const generateNewDeviceId = (): string => {
  const deviceId = crypto.randomUUID();
  localStorage.setItem(STORAGE_KEYS.DEVICE_ID, deviceId);
  return deviceId;
};
